import React, { useLayoutEffect, useRef } from "react";
import "./intro.css";
import ramin from "../../assets/ramin-400.jpg";
import { gsap } from "gsap";

function Intro() {
  const introRef = useRef();

  useLayoutEffect(() => {
    // Simple fade-in animation
    const tween = gsap.fromTo(
      introRef.current,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
    return () => tween.kill();
  }, []);

  return (
    <section id="intro">
      <div id="intro-wrapper" className="intro-container frost" ref={introRef}>
        <div id="intro-title-wrapper" className="intro-left">
          <h1 id="intro-title">Hey there!</h1>
          <div className="intro-left">
            I'm Ramin, an incoming PhD student in the HST Medical Engineering and Medical Physics program at MIT.
          </div>
          <div style={{ height: "1rem" }}></div>
          <div className="intro-left">
            My research interests are in applying machine learning to medical images and text data to improve clinical decision making.
          </div>
          <div style={{ height: "1rem" }}></div>
          <div className="intro-left">
            Feel free to reach out at <a href="mailto:raminkah@mit.edu">raminkah@mit.edu.</a>
          </div>
        </div>

        <div className="intro-right">
          <img id="intro-image" className="intro-right" src={ramin} alt="Ramin Kahidi" width="200" height="200" />

        </div>
      </div>
    </section>
  );
}

export default Intro;
